"use strict";

var resetService = angular.module('resetService', ['awardCalculation', 'determineAward']);
resetService.service('ResetService', function(ApplicationService, authServiceFactory, HousingService, $q, $http,
                                              PutService, EditSumsModelFactory, EditSumsModelService, FmThresholdsModelFactory, MainContentService,
                                              CalculationService, ApWizardModelFactory, AppModelService, FamilyThresholdsService,
                                              SchoolModelService, AddedAllowanceModelFactory, ApplicantModelService, DetermineAwardService,
                                              ApplicationSideBarService, CheckListService, $rootScope, AlertService, GradeSetupModelService,
                                              BudgetsModelService, LivingAllowanceCalcService, SliderService) {

    var auth;

    this.init = function()
    {
        auth = SchoolModelService.get()[0];
    }


    //--------------------------------------------------------------------------
    //----------------------- Helper Methods -----------------------------------
    //--------------------------------------------------------------------------

    var resetValue = function(orig, edit)
    {
        if (orig !== null)
            edit = orig;
        else
            edit = 0; 
        return edit;
    }

    // Reset added allowance corresponding to a single policy flag
    let resetSingleAddedAllowance = function(i, caseNo) {
        let model = new AddedAllowanceModelFactory(ApplicationService.getFamilyID(i));
        let answer = ApplicationService.getAwardData().family[i].apWizard["case" + caseNo + "ans"];
        if (answer.length > 1) {
            let answerObj = JSON.parse(answer);
            let addedAllowance = model.getById(answerObj.allowanceID);
            if (addedAllowance) {
                model.purge(answerObj.allowanceID, addedAllowance);
            }
        }
    };

    // Set alert values in apWizard back to default
    this.resetAlert = function(caseNo, i)
    {
        ApplicationService.getAwardData().family[i].apWizard['case' + caseNo] = 1;
        ApplicationService.getAwardData().family[i].apWizard['case' + caseNo + 'ans'] = "";
    }


    //--------------------------------------------------------------------------
    //------------- Award Calculation Resets -----------------------------------
    //--------------------------------------------------------------------------

    this.resetIncome = function(i) // Reset Reported Income fields
    {
        var family =   ApplicationService.getAwardData().family[i];
        var income_property, income;
        for(var property in family.income)
        {
            if ((ApplicationService.getAwardData().app[0].Tax_State==1 || ApplicationService.getAwardData().app[0].Tax_State==2) && //taxes == verified
                property !== 'Inc_Estate' && property !== 'Inc_Child_Supp' && property !== 'Inc_Alimony' && property !== 'Inc_Gifts')
            {
                income = family.ism_edits;
                income_property = property.replace("Inc", "ISM");
            }
            else
            {
                income = family.income;
                income_property = property;
            }

            if (property == 'Inc_Annual' && (ApplicationService.getAwardData().app[0].Tax_State==1 || ApplicationService.getAwardData().app[0].Tax_State==2))
            {
                property += "_1";
                income_property += "_1";
            }
            else if (property == 'Inc_Annual')
            {
                property += "_1";
            }

            if (typeof family.edit_sums[property] !== 'undefined' && typeof income[income_property] !== 'undefined')
                family.edit_sums[property] = resetValue(income[income_property], family.edit_sums[property]);
        }

        family.edit_sums.Exp_Child_Supp = resetValue(family.expense.Exp_Child_Supp,
            family.edit_sums.Exp_Child_Supp);
        family.edit_sums.Exp_Alimony = resetValue(family.expense.Exp_Alimony,
            family.edit_sums.Exp_Alimony);

    }

    this.resetAssets = function(i)
    {
        for(var property in ApplicationService.getAwardData().family[i].asset)
        {
            if (property == 'Asset_Home_PMV')
                ApplicationService.getAwardData().family[i].edit_sums['Rea_PMV'] = resetValue(ApplicationService.getAwardData().family[i].asset[property],
                    ApplicationService.getAwardData().family[i].edit_sums['Rea_PMV']);
            else if (property == 'Asset_Other_Rea_PMV')
                ApplicationService.getAwardData().family[i].edit_sums['Oth_PMV'] = resetValue(ApplicationService.getAwardData().family[i].asset[property],
                    ApplicationService.getAwardData().family[i].edit_sums['Oth_PMV']);
            else if (property == 'Asset_Vehicle_PMV')
                ApplicationService.getAwardData().family[i].edit_sums['Veh_EMV'] = resetValue(ApplicationService.getAwardData().family[i].asset[property],
                    ApplicationService.getAwardData().family[i].edit_sums['Veh_EMV']);
            else if (typeof ApplicationService.getAwardData().family[i].edit_sums[property] !== 'undefined')
                ApplicationService.getAwardData().family[i].edit_sums[property] =
                    resetValue(ApplicationService.getAwardData().family[i].asset[property], ApplicationService.getAwardData().family[i].edit_sums[property]);
        }
    }

    this.resetLiabilities = function(i)
    {
        for(var property in ApplicationService.getAwardData().family[i].liab)
        {
            if (property == 'Family_Home_Principle')
                ApplicationService.getAwardData().family[i].edit_sums['Rea_Principle'] = resetValue(ApplicationService.getAwardData().family[i].liab[property],
                    ApplicationService.getAwardData().family[i].edit_sums['Rea_Principle']);
            else if (property == 'Other_Rea_Principle')
                ApplicationService.getAwardData().family[i].edit_sums['Oth_Principle'] = resetValue(ApplicationService.getAwardData().family[i].liab[property],
                    ApplicationService.getAwardData().family[i].edit_sums['Oth_Principle']);
            else if (property == 'Veh_Remaining_Balance')
                ApplicationService.getAwardData().family[i].edit_sums['Veh_Debt_Out'] = resetValue(ApplicationService.getAwardData().family[i].liab[property],
                    ApplicationService.getAwardData().family[i].edit_sums['Veh_Debt_Out']);
            else if (typeof ApplicationService.getAwardData().family[i].edit_sums[property] !== 'undefined')
                ApplicationService.getAwardData().family[i].edit_sums[property] =
                    resetValue(ApplicationService.getAwardData().family[i].liab[property], ApplicationService.getAwardData().family[i].edit_sums[property]);
        }
    }

    this.resetImputed_Income = function(i)
    {
        ApplicationService.getAwardData().family[i].thresholds.Retire = auth.Retire;
        ApplicationService.getAwardData().family[i].thresholds.Equity = auth.Equity;
        ApplicationService.getAwardData().family[i].thresholds.Thresh_Assets_Cap = auth.Thresh_Assets_Cap;
        ApplicationService.getAwardData().family[i].thresholds.Thresh_Assets_Percent = auth.Thresh_Assets_Percent;
        this.resetAssets(i);
        this.resetLiabilities(i);
    }

    this.resetLiving_Allowance = function (i)
    {
        ApplicationService.getAwardData().family[i].thresholds.Thresh_Living_Allowance = auth.Thresh_Living_Allowance;
        ApplicationService.getAwardData().family[i].thresholds.Thresh_Allow_Per_Child = auth.Thresh_Allow_Per_Child;
        ApplicationService.getFamilyData().edit_sums.Exp_Added = 0;
        ApplicationService.getAwardData().family[i].edit_sums.Applicant_Count = ApplicationService.getAwardData().applicants.length;
        ApplicationService.getAwardData().family[i].edit_sums.Child_Count = ApplicationService.getAwardData().family[i].children.length;
        var model = new AddedAllowanceModelFactory(ApplicationService.getFamilyID(i));
        model.purgeAll(ApplicationService.getFamilyID(i), null, null);
        ApplicationService.getFamilyData().addedAllowance = [];
        
        // since we reset added allowances, we need to reset these alerts, because their corresponding
        // values in the added allowances list could have been removed
        this.resetAlert(79, i); // also reset added allowance alert
        this.resetAlert(84, i); // also reset assets alert
        this.resetAlert(70, i); // also reset college tuition alert
        this.resetAlert(69, i); // also reset other tuition alert
        this.resetAlert(82, i); // also reset medical alert
        this.resetAlert(83, i); // also reset childcare alert

    }

    this.resetHousing = function(i)
    {
        var orginalHousing = HousingService.getOrignalHousing();
        ApplicationService.getAwardData().family[i].edit_sums.Rea_Mort_Pay = orginalHousing.Rea_Mort_Pay;
        ApplicationService.getAwardData().family[i].edit_sums.Exp_Rent = ApplicationService.getAwardData().family[i].expense.Exp_Rent;
        ApplicationService.getAwardData().family[i].edit_sums.Rea_Property_Tax = orginalHousing.Rea_Property_Tax;
        ApplicationService.getAwardData().family[i].edit_sums.Exp_Home_Ins = ApplicationService.getAwardData().family[i].expense.Exp_Home_Ins;
        ApplicationService.getAwardData().family[i].thresholds.Thresh_Housing_Percent = auth.Thresh_Housing_Percent;
        ApplicationService.getAwardData().family[i].thresholds.Thresh_Housing_Cap = auth.Thresh_Housing_Cap;
    }

    this.resetUtilities = function(i)
    {
        ApplicationService.getAwardData().family[i].edit_sums.Exp_Elec = ApplicationService.getAwardData().family[i].expense.Exp_Elec;
        ApplicationService.getAwardData().family[i].edit_sums.Exp_Heat = ApplicationService.getAwardData().family[i].expense.Exp_Heat;
        ApplicationService.getAwardData().family[i].thresholds.Thresh_Utilities_Percent = auth.Thresh_Utilities_Percent;
        ApplicationService.getAwardData().family[i].thresholds.Thresh_Utilities_Cap = auth.Thresh_Utilities_Cap;
    }

    this.resetInsurances = function(i)
    {
        ApplicationService.getAwardData().family[i].edit_sums.Exp_Health_Ins = ApplicationService.getAwardData().family[i].expense.Exp_Health_Ins;
        ApplicationService.getAwardData().family[i].edit_sums.Exp_Auto_Ins = ApplicationService.getAwardData().family[i].expense.Exp_Auto_Ins;
        ApplicationService.getAwardData().family[i].edit_sums.Exp_Life_Ins = ApplicationService.getAwardData().family[i].expense.Exp_Life_Ins;
        ApplicationService.getAwardData().family[i].thresholds.Thresh_Insurances_Cap_A = auth.Thresh_Insurances_Cap_A;
        ApplicationService.getAwardData().family[i].thresholds.Thresh_Insurances_Cap_L = auth.Thresh_Insurances_Cap_L;
    }


    this.resetTaxes = function(i)
    {
        ApplicationService.getAwardData().family[i].edit_sums.Exp_Fed_Tax = ApplicationService.getAwardData().family[i].expense.Exp_Fed_Tax;
        ApplicationService.getAwardData().family[i].edit_sums.Exp_State_Tax = ApplicationService.getAwardData().family[i].expense.Exp_State_Tax;
    }

    this.resetAllowed_Savings = function(i)
    {
        ApplicationService.getAwardData().family[i].thresholds.Thresh_Savings_Allowed_Percent = auth.Thresh_Savings_Allowed_Percent;
        ApplicationService.getAwardData().family[i].thresholds.Thresh_Savings_Allowed_Cap = auth.Thresh_Savings_Allowed_Cap;
    }

    this.resetCharity = function(i)
    {
        ApplicationService.getAwardData().family[i].edit_sums.Exp_Charity = ApplicationService.getAwardData().family[i].expense.Exp_Charity;
        ApplicationService.getAwardData().family[i].thresholds.Thresh_Charity_Percent = auth.Thresh_Charity_Percent;
        ApplicationService.getAwardData().family[i].thresholds.Thresh_Charity_Cap = auth.Thresh_Charity_Cap;
    }

    this.resetTuition = function(i)
    {
        var items = GradeSetupModelService.get();
        ApplicationService.getAwardData().family[i].edit_sums.Applicant_Total = 0;
        for (var k = 0; k < ApplicationService.getAwardData().applicants.length; k++) {
            for (var j = 0; j < items.length; j++) {
                var applDivCode = ApplicationService.getAwardData().applicants[k].xApp_Div_Code ? ApplicationService.getAwardData().applicants[k].xApp_Div_Code : ApplicationService.getAwardData().applicants[k].App_Div_Code;
                if (applDivCode == items[j].DivisionCode) {
                    ApplicationService.getAwardData().applicants[k].App_Tuition = items[j].tuition;
                    ApplicationService.getFamilyData().edit_sums.Applicant_Total += parseInt(ApplicationService.getAwardData().applicants[k].App_Tuition);
                    ApplicantModelService.put(ApplicationService.getAwardData().applicants[k].recordID, ApplicationService.getAwardData().applicants[k]);
                }
            }
        }
        ApplicationService.getAwardData().tuition = ApplicationService.getFamilyData().edit_sums.Applicant_Total;
        
        this.resetAlert(78, i);
    }



    //--------------------------------------------------------------------------
    //------------------ Policy Alert Resets -----------------------------------
    //--------------------------------------------------------------------------


    this.resetMedical_Expenses_Reported_Alert = function(i) {
        resetSingleAddedAllowance(i, 82);
        this.resetAlert(82, i);
    };

    this.resetChildcare_Expenses_Reported_Alert = function(i) {
        resetSingleAddedAllowance(i, 83);
        this.resetAlert(83, i);
    };

    this.resetAssets_Reported_Alert = function(i)
    {
        var self = this;
        var queue = [];
        var model = new AddedAllowanceModelFactory(ApplicationService.getFamilyID(i));
        var answer = ApplicationService.getAwardData().family[i].apWizard['case84ans'];
        if (answer.length > 1)
        {
            var answerObj = JSON.parse(answer);
            if (model.getById(answerObj['savings'].allowanceID))
                queue.push(model.purge(answerObj.allowanceID, model.getById(answerObj['savings'].allowanceID)));
            if (model.getById(answerObj['checking'].allowanceID))
                queue.push(model.purge(answerObj.allowanceID, model.getById(answerObj['checking'].allowanceID)));
            if (model.getById(answerObj['stock'].allowanceID))
                queue.push(model.purge(answerObj.allowanceID, model.getById(answerObj['stock'].allowanceID)));
        }

        var promise = $q.defer();
        $q.all(queue).then(function() {
            // recalculate living allowance and reset alert
            LivingAllowanceCalcService.calculate();
            self.resetAlert(84, i);
            promise.resolve();
        });
        return promise.promise;
    }

    this.resetTuition_Adjustment_Alert = function(i)
    {
        ApplicationService.getAwardData().family[i].edit_sums.Applicant_Total = 0;  
        for (var k = 0; k < ApplicationService.getAwardData().applicants.length; k++) {
            //set tuition back to original
            ApplicationService.getAwardData().applicants[k].App_Tuition = ApplicationService.getAwardData().applicants[k].tuition;

            ApplicationService.getFamilyData().edit_sums.Applicant_Total += parseInt(ApplicationService.getAwardData().applicants[k].App_Tuition); // add up total tuiion
            ApplicantModelService.put(ApplicationService.getAwardData().applicants[k].applicationID, ApplicationService.getAwardData().applicants[k]); //update applicant
        }

        EditSumsModelService.put(ApplicationService.getFamilyData().data[0].familyID, ApplicationService.getFamilyData().edit_sums);
        ApplicationService.getAwardData().tuition = ApplicationService.getFamilyData().edit_sums.Applicant_Total; 

        this.resetAlert(78, i);
    }

    this.resetAdded_Allowance_Alert = function(i)
    {
        try { //this will fail if value is empty string
            var obj = JSON.parse(ApplicationService.getAwardData().family[i].apWizard['case' + '79' + 'ans']);
        } catch(e) {}
        if (obj) { // if obj has a value
            // remove added allowance from the added allowance array
            ApplicationService.getFamilyData().addedAllowance.forEach(function(v, i, a) {
                if (obj.recordID==v.recordID) {
                    a.splice(i, 1);
                }
            });

            // reset custom added allowance
            var model = new AddedAllowanceModelFactory(ApplicationService.getFamilyID(i));
            model.purge(ApplicationService.getFamilyID(i), obj); 
        }

        // put edit sums & recalculate living allowance
        LivingAllowanceCalcService.calculate();
        EditSumsModelService.put(ApplicationService.getFamilyData().data[0].familyID, ApplicationService.getFamilyData().edit_sums).then( function() {
            CalculationService.reCalc();
        });
        this.resetAlert(79, i);
    }

    this.resetBusiness_Income_Reported_Alert = function(i)
    {
        var family = ApplicationService.getAwardData().family[i];

        if ((i==0 && ApplicationService.getAwardData().app[0].Tax_State!=1) || (i==1 && ApplicationService.getAwardData().app[0].Tax_State_F2!=1))
            family.edit_sums["Inc_Business"] = resetValue(family.income["Inc_Business"], family.edit_sums["Inc_Business"]);
        else
            family.edit_sums["Inc_Business"] = resetValue(family.ism_edits["ISM_Business"], family.edit_sums["Inc_Business"]);
        this.resetAlert(66, i);
    }

    this.resetHomemaker_Alert = function(i)
    {
        var family = ApplicationService.getAwardData().family[i];
        var income, income_field, field;
        for (var j = 0 ; j < family.data.length; j++)
        {
            if(family.data[j]['Fam_Occupation'] == "Homemaker")
                field = "Inc_Annual_" + (j + 1);
        }
        if (field)
        {
            if ((i==0 && ApplicationService.getAwardData().app[0].Tax_State!=1) || (i==1 && ApplicationService.getAwardData().app[0].Tax_State_F2!=1)) {
                income_field = field;
                income = family.income;
            }
            else {
                income_field = field.replace("Inc", "ISM");
                income = family.ism_edits;
            }

            if (typeof income[income_field] == 'undefined')
                income_field = "Inc_Annual";
            family.edit_sums[field] = resetValue(income[income_field], family.edit_sums[field]);
        }
        this.resetAlert(67, i);
    }

    this.resetLow_Income_Alert = function(i) {
        let family = ApplicationService.getAwardData().family[i];
        let income, income_field, field;
        for (let j = 0 ; j < family.data.length; j++) {
            if(family.data[j]["Fam_Occupation"] !== "Homemaker") {
                field = "Inc_Annual_" + (j + 1);
            }
        }
        if (field) {
            if ((i==0 && ApplicationService.getAwardData().app[0].Tax_State!=1) 
                || (i==1 && ApplicationService.getAwardData().app[0].Tax_State_F2!=1)) {
                income_field = field;
                income = family.income;
            } else {
                income_field = field.replace("Inc", "ISM");
                income = family.ism_edits;
            }

            if (typeof income[income_field] == "undefined") {
                income_field = "Inc_Annual";
            }
            family.edit_sums[field] = resetValue(income[income_field], family.edit_sums[field]);
        }
        this.resetAlert(68, i);
    };

    this.resetUtilities_Threshold_Exceeded_Alert = function(i)
    {
        ApplicationService.getAwardData().family[i].thresholds.Thresh_Utilities_Percent = auth.Thresh_Utilities_Percent;
        ApplicationService.getAwardData().family[i].thresholds.Thresh_Utilities_Cap = auth.Thresh_Utilities_Cap;
        this.resetAlert(73, i);
    }

    this.resetLife_Insurance_Threshold_Exceeded_Alert = function(i)
    {
        ApplicationService.getAwardData().family[i].thresholds.Thresh_Insurances_Cap_L = auth.Thresh_Insurances_Cap_L;
        this.resetAlert(75, i);
    }

    this.resetAuto_Insurance_Threshold_Exceeded_Alert = function(i)
    {
        ApplicationService.getAwardData().family[i].thresholds.Thresh_Insurances_Cap_A = auth.Thresh_Insurances_Cap_A;
        this.resetAlert(74, i);
    }

    this.resetCharity_Threshold_Exceeded_Alert = function(i)
    {
        ApplicationService.getAwardData().family[i].thresholds.Thresh_Charity_Percent = auth.Thresh_Charity_Percent;
        ApplicationService.getAwardData().family[i].thresholds.Thresh_Charity_Cap = auth.Thresh_Charity_Cap;
        this.resetAlert(77, i);
    }

    this.resetHousing_Threshold_Exceeded_Alert = function(i)
    {
        ApplicationService.getAwardData().family[i].thresholds.Thresh_Housing_Percent = auth.Thresh_Housing_Percent;
        ApplicationService.getAwardData().family[i].thresholds.Thresh_Housing_Cap = auth.Thresh_Housing_Cap;
        this.resetAlert(72, i);
        //this.resetLiving_Allowance(i);
    }

    this.resetIncome_Change_Alert = function(i)
    {
        var family = ApplicationService.getAwardData().family[i];
        if ((i==0 && ApplicationService.getAwardData().app[0].Tax_State!=1) || (i==1 && ApplicationService.getAwardData().app[0].Tax_State_F2!=1))
        {
            family.edit_sums["Inc_Annual_1"] = resetValue(family.income["Inc_Annual"], family.edit_sums["Inc_Annual_1"]);
            family.edit_sums["Inc_Annual_2"] = resetValue(family.income["Inc_Annual_2"], family.edit_sums["Inc_Annual_2"]);
        }
        else
        {
            family.edit_sums["Inc_Annual_1"] = resetValue(family.ism_edits["ISM_Annual_1"], family.edit_sums["Inc_Annual_1"]);
            family.edit_sums["Inc_Annual_2"] = resetValue(family.ism_edits["ISM_Annual_2"], family.edit_sums["Inc_Annual_2"]);
        }
        this.resetAlert(81, i);
    }

    this.resetPercent_Tuition_Alert = function(i)
    {
        //reset everything back to 100-100
        let putObject = {
            familyID: ApplicationService.getAwardData().family[0].data[0].familyID,
            Thresh_Fam1_Tuition_Percent: 100,
            Thresh_Fam2_Tuition_Percent: 100
        };
        // family 1
        FamilyThresholdsService.put(putObject);
        // family 2
        putObject.familyID = ApplicationService.getAwardData().family[1].data[0].familyID;
        FamilyThresholdsService.put(putObject);

        ApplicationService.getAwardData().family[0].thresholds.Thresh_Fam1_Tuition_Percent = 100;
        ApplicationService.getAwardData().family[0].thresholds.Thresh_Fam2_Tuition_Percent = 100;
        ApplicationService.getAwardData().family[1].thresholds.Thresh_Fam1_Tuition_Percent = 100;
        ApplicationService.getAwardData().family[1].thresholds.Thresh_Fam2_Tuition_Percent = 100;
        //reset both families
        this.resetAlert(85, 0);
        this.resetAlert(85, 1);
        AlertService.getAlerts()["percentTuition"].state = "warning";
    }

    this.resetCollege_Tuition_Reported_Alert = function(i)
    {
        resetSingleAddedAllowance(i, 70);
        this.resetAlert(70, i);
    }

    this.resetOther_Tuition_Reported_Alert = function(i)
    {
        resetSingleAddedAllowance(i, 69);
        this.resetAlert(69, i);
    }

    this.resetTwo_Families_Present_Alert = function(i)
    {
        // data manipulation since we store duplicate data for Thresh_Famx_Percent per-family
        // copy the thresh_famx_percent column to the other family
        let otherFamIndex = ApplicationService.getFamilyNo() * -1 + 1;
        ApplicationService.getFamilyData(i).thresholds['Thresh_Fam' + (i + 1) + '_Percent'] = ApplicationService.getAwardData().policy[0]['Pref_6_default_' + (1)];
        ApplicationService.getFamilyData(otherFamIndex).thresholds['Thresh_Fam' + (i + 1) + '_Percent'] = ApplicationService.getAwardData().policy[0]['Pref_6_default_' + (1)];
        this.resetAlert(80, i);
    }



    //--------------------------------------------------------------------------
    //------------------ Other Resets ------------------------------------------
    //--------------------------------------------------------------------------

    var resetBudgets = function()
    {
        for (var p = 0; p < ApplicationService.getAwardData().applicants.length; p++) {
            for (var q = 0; q < ApplicationService.getAwardData().applicants[p].budgets.length; q++) {
                BudgetsModelService.purge(ApplicationService.getAwardData().app[0].applicationID, ApplicationService.getAwardData().applicants[p].budgets[q]);
                ApplicationService.getAwardData().applicants[p].budgets[q].award = 0;
            }
        }
    }

    this.resetAward = function(i)
    {
        resetBudgets();
        for(var t=0; t < ApplicationService.getAwardData().applicants.length; t++) {
            var id = ApplicationService.getAwardData().applicants[t].recordID;
            ApplicationService.getAwardData().applicants[t];
            ApplicationService.getAwardData().applicants[t].ActAward = 0;
            ApplicationService.getAwardData().applicants[t].ActAward_F1 = 0;
            ApplicationService.getAwardData().applicants[t].ActAward_F2 = 0;
            ApplicationService.getAwardData().applicants[t].ConsiderAward = 0;
            ApplicationService.getAwardData().applicants[t].ConsiderAward_F1 = 0;
            ApplicationService.getAwardData().applicants[t].ConsiderAward_F2 = 0;
            var applicant = angular.copy(ApplicationService.getAwardData().applicants[t]);
            //delete applicant name (in case school is using anon mode)
            delete applicant.App_Last;
            delete applicant.App_Middle;
            delete applicant.App_First;

            ApplicantModelService.put(id, applicant);
        }

        ApplicationService.getAwardData().app[0].Award_Amount = 0;
        AppModelService.put(ApplicationService.getApplicationID(), { Award_Amount: 0 }).then(function () {
            if ((ApplicationService.getAwardData().app[0].Status_Award == "1") || (ApplicationService.getAwardData().app[0].Status_Consider == "1") || (ApplicationService.getAwardData().app[0].Status_Reject == "1")) {
                ApplicationSideBarService.setBin('Status_Viewed');
            }
            DetermineAwardService.resetAwardComplete();
        });
    };

    this.resetItems_of_Interest = function(i)
    {
        var id =ApplicationService.getFamilyID(i);
        $http.put('api/family/'+id+'/FamIsmFlags', {'weight': null, complete:0}).then(function() {
            CheckListService.resetItems(i);
            CheckListService.counts[i].complete.interest = 0;
        })
    }

    this.resetProcess = function(i)
    {
        var id =ApplicationService.getFamilyID(i);
        var ApWizardModelService = new ApWizardModelFactory(id);
        ApplicationService.getFamilyData().apWizard.viewedLetter = 0;
        ApplicationService.getFamilyData().apWizard.viewedSsq = 0;
        ApplicationService.getFamilyData().apWizard.viewedOtherDesc = 0;
        ApplicationService.getFamilyData().apWizard.viewedFamily = 0;
        ApWizardModelService.put(id, ApplicationService.getFamilyData().apWizard)
        CheckListService.counts[i].complete.process = 0;
        //this.counts[fam].complete = {policy: 0, interest: 0, process: 0, award: 0};
    }
    
    this.resetAll = function(fam, $modalInstance)
    {
        var parent = this;
        swal({
            title: "Are you sure?",
            text: "This will remove all changes you have made to the application.",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Yes, reset it!",
            closeOnConfirm: false
        },
        function(){ //What happens when you click ok
            var promises = [];
            for (var i = 0; i < ApplicationService.getAwardData().family.length; i ++)
            {
                var famIndex = i + 1;
                var id =ApplicationService.getFamilyID(i);
                var ApWizardModelService = new ApWizardModelFactory(id);
                var EditSumsModelService = new EditSumsModelFactory(id);
                var FamilyThresholdsModelService = new FmThresholdsModelFactory(id);
                for (var key in fam[famIndex])
                {
                    if (fam[famIndex][key] == true)
                    {
                        try {
                            parent["reset" + key](i);
                        } catch(e) { console.error("reset" + key + " failed"); }
                    }
                }
                //promises.push(PutService.putEditSums(i));
                promises.push(EditSumsModelService.put(id, EditSumsModelService.get(i)));
                promises.push(FamilyThresholdsModelService.put(id, FamilyThresholdsModelService.get(i)));
                promises.push(ApWizardModelService.put(id, ApWizardModelService.get(i)));

            }
            if (fam[0]["Award"] == true)
            {
                parent["resetAward"](i);
            }

            $q.all(promises).then(function (results) {
                CalculationService.reCalc();
            });
            $modalInstance.dismiss('done');
            MainContentService.setActiveDiv('applicationOverview')

            swal("Reset!", "The Application has been reset.", "success");
        });
    }

    // reset individual section/alert with 'are you sure' prompt
    this.resetWithPrompt = function(section, name)
    {
        var i = ApplicationService.getFamilyNo();  
        var parent = this;
        swal({
            title: "Are you sure?",
            text: "Are you sure you want to reset the " + section.replaceAll("_", " ") + " section?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Yes, reset it!",
            closeOnConfirm: false
        },
        function(){ //What happens when you click ok
            parent.resetNoPrompt(section);
            swal("Reset!", "The Application has been reset.", "success");
            SliderService.closeSlider();
        });
    };

    // reset individual section/slert without prompt
    this.resetNoPrompt = function(section)
    {
        let i = ApplicationService.getFamilyNo();  
        let promises = [];
        let id =ApplicationService.getFamilyID(i);
        let ApWizardModelService = new ApWizardModelFactory(id);
        let EditSumsModelService = new EditSumsModelFactory(id);

        // if reset method returns a promise, wait for it, otherwise use an empty promise
        try {
            $q.when(this["reset" + section](i))
            .then(function() {
                promises.push(EditSumsModelService.put(id, EditSumsModelService.get(i)));
                promises.push(PutService.putThresholds());
                promises.push(ApWizardModelService.put(id, ApWizardModelService.get(i)));
                return $q.all(promises).then(function (results) {
                    CalculationService.reCalc();
                    CheckListService.resetItems(i);
                    CheckListService.init();
                    swal("Reset!", "The Application has been reset.", "success");
                });
            });
        } catch(e) {
            swal("Error!", "There was an error in resetting.", "error");
            console.error("reset" + section + " failed");
        }
    };



    /* Method Aliases */

    this.resetmedicalExpensesReported = this.resetMedical_Expenses_Reported_Alert;

    this.resetchildcareExpensesReported = this.resetChildcare_Expenses_Reported_Alert;

    this.resetassetsReported = this.resetAssets_Reported_Alert;

    this.resetaddedAllowance =  this.resetAdded_Allowance_Alert;

    this.resetautoInsuranceThresholdExceeded = this.resetAuto_Insurance_Threshold_Exceeded_Alert;

    this.resetbusinessIncomeReported = this.resetBusiness_Income_Reported_Alert;

    this.resetcharityThresholdExceeded = this.resetCharity_Threshold_Exceeded_Alert;

    this.resetcollegeTuitionReported = this.resetCollege_Tuition_Reported_Alert;

    this.resethomemakerDetected = this.resetHomemaker_Alert;

    this.resethousingThresholdExceeded = this.resetHousing_Threshold_Exceeded_Alert;

    this.resetincomeChange = this.resetIncome_Change_Alert;

    this.resetpercentTuition = this.resetPercent_Tuition_Alert;

    this.resetlifeInsuranceThresholdExceeded = this.resetLife_Insurance_Threshold_Exceeded_Alert;

    this.resetlowIncomeDetected = this.resetLow_Income_Alert;

    this.resetotherTuitionReported = this.resetOther_Tuition_Reported_Alert;

    this.resettuitionAdjustment = this.resetTuition_Adjustment_Alert;

    this.resettwoFamiliesPresent = this.resetTwo_Families_Present_Alert;

    this.resetutilitiesThresholdExceeded = this.resetUtilities_Threshold_Exceeded_Alert;

    this.resetimputedIncome = this.resetImputed_Income;


    this.init();

});
